import round from 'lodash/round'

export const calculateConvertedAmount = (exchangeRate: number, amount?: number): number => {
  if (!amount) {
    return 0
  }

  return round(amount * exchangeRate, 2)
}
